import { initialize } from '@doordash/lib-i18n';
import config from './translations/i18n_config.json';
var i18n = initialize(config);
export default i18n;
